import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w-100 flex justify-center mb-12" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-y-16 gap-x-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_frame_component = _resolveComponent("frame-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitPictures, (pics, index) => {
        return (_openBlock(), _createBlock(_component_frame_component, {
          key: index,
          pictures: pics
        }, null, 8, ["pictures"]))
      }), 128))
    ])
  ]))
}